
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from './locales/en/translation.json';
import arTranslation from './locales/ar/translation.json';
import frTranslation from './locales/fr/translation.json';

// Configuration options
const resources = {
  en: {
    translation: enTranslation
  },
  ar: {
    translation: arTranslation
  },
  fr: {
    translation: frTranslation
  }
};

// Define supported languages and their RTL status
const supportedLanguages = ['fr', 'en', 'ar'];
const isRTL = (lng: string) => lng === 'ar';

i18n
  // Use language detector
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'fr', // Default fallback is still French
    supportedLngs: supportedLanguages,
    debug: false,

    interpolation: {
      escapeValue: false, // React already safes from XSS
    },

    // Better handle Arabic text direction
    react: {
      useSuspense: true,
    },
    
    // Language detection configuration
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Keys to use in localStorage
      lookupLocalStorage: 'i18nextLng',
      // Cache user language
      caches: ['localStorage']
    }
  });

// Helper function to toggle between languages
export const toggleLanguage = () => {
  const currentLang = i18n.language;
  let newLang = 'fr';
  
  // Cycle through languages: fr -> en -> ar -> fr
  if (currentLang === 'fr') newLang = 'en';
  else if (currentLang === 'en') newLang = 'ar';
  else if (currentLang === 'ar') newLang = 'fr';
  
  // Update document direction for RTL support
  document.documentElement.dir = isRTL(newLang) ? 'rtl' : 'ltr';
  document.documentElement.lang = newLang;
  
  i18n.changeLanguage(newLang);
  return newLang;
};

// Set initial direction based on current language
document.documentElement.dir = isRTL(i18n.language) ? 'rtl' : 'ltr';
document.documentElement.lang = i18n.language;

export default i18n;
